import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function SubscriptionCancelled() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl p-12 max-w-2xl w-full text-center">
        <XCircle className="w-24 h-24 text-orange-500 mx-auto mb-6" />
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Payment Cancelled
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          No worries! Your payment was not processed.
        </p>
        
        <div className="bg-orange-50 border border-orange-200 rounded-lg p-6 mb-8">
          <p className="text-orange-800 mb-4">
            You can try again anytime or continue using the free plan.
          </p>
        </div>

        <div className="flex gap-4 justify-center">
          <Button
            onClick={() => navigate('/pricing')}
            className="bg-blue-600 hover:bg-blue-700 px-8 py-6 text-lg"
          >
            View Pricing Again
          </Button>
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="px-8 py-6 text-lg"
          >
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
